// extracted by mini-css-extract-plugin
export default {"subtitle":"Question-module__subtitle-QWwtr0"};